export default __webpack_public_path__ + "static/media/file-alt.a16065a0.svg";